import { MenuList } from '@mui/material';
import Paper from '@mui/material/Paper';
import CustomPopover from 'common/components/PopoversAndDialogs/CustomPopover';
import SettingsMenuItem from 'common/features/settingsMenu/components/SettingsMenuItem';
import useFlexBoxStyles from 'common/flexBox';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    getAudioDeviceId,
    getAudioDevices,
    getVideoDeviceId,
    getVideoDevices,
    setAudioDeviceId,
    setVideoDeviceId,
} from 'redux/slices/shortVideoSlice';

const ShortVideoSettingsMedia = (props) => {
    const { type, handleOnClose, anchorEl } = props;
    const dispatch = useDispatch();
    const { classes: flexBox, cx } = useFlexBoxStyles();
    const videoDeviceId = useSelector(getVideoDeviceId);
    const audioDeviceId = useSelector(getAudioDeviceId);
    const videoDevices = useSelector(getVideoDevices);
    const audioDevices = useSelector(getAudioDevices);
    const devices = type === 'videoinput' ? videoDevices : audioDevices;
    const selected = type === 'videoinput' ? videoDeviceId : audioDeviceId;

    const handleChange = (e, deviceId) => {
        if (type === 'videoinput') {
            dispatch(setVideoDeviceId(deviceId));
        } else if (type === 'audioinput') {
            dispatch(setAudioDeviceId(deviceId));
        }
        handleOnClose();
    };

    const handleListKeyDown = useCallback(
        (event) => {
            if (event.key === 'Tab') {
                event.preventDefault();
                handleOnClose();
            }
        },
        [handleOnClose],
    );

    return (
        <CustomPopover
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            hideCloseButton={true}
            anchorEl={anchorEl}
            open={true}
            disablePortal={true}
            handleOnClose={handleOnClose}
        >
            <Paper className={cx(flexBox.borderRadius2, flexBox.overflowHidden)}>
                <MenuList
                    autoFocusItem={true}
                    id="menu-list-grow"
                    onKeyDown={handleListKeyDown}
                    className={flexBox.padding0}
                >
                    {devices?.map((device, idx) => (
                        <SettingsMenuItem
                            id="onlive-menu-item-media"
                            key={device.deviceId}
                            onClick={(e) => handleChange(e, device.deviceId)}
                            selected={selected === device.deviceId}
                        >
                            {device.label}
                        </SettingsMenuItem>
                    ))}
                </MenuList>
            </Paper>
        </CustomPopover>
    );
};

export default ShortVideoSettingsMedia;
